/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { Text } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import type { TemplateRecommendationId } from '../../../common/types.tsx';
import {
	descriptionsMessagesMapping,
	descriptionsMessagesMappingOld,
	headingMessagesMapping,
	headingMessagesMappingOld,
} from './constants.tsx';

export const ExplainerSection = ({ templateId }: { templateId: TemplateRecommendationId }) => {
	const { formatMessage } = useIntl();

	const heading = (
		fg('jira-issue-terminology-update-m4') ? headingMessagesMapping : headingMessagesMappingOld
	)[templateId];
	const description = (
		fg('jira-issue-terminology-update-m4')
			? descriptionsMessagesMapping
			: descriptionsMessagesMappingOld
	)[templateId];
	if (!heading || !description) return null;

	return (
		<>
			<Heading size="xsmall" as="div">
				{formatMessage(heading)}
			</Heading>
			<Text as="p">{formatMessage(description)}</Text>
		</>
	);
};
